import { useSearchQueryFilter } from '@aibees/elephant/hooks';
import { SearchMatchType } from '@aibees/elephant/types';
import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import { SearchMatchButton } from '../../components/search-match-button';
import { SEARCH_MATCH_BUTTONS_CONFIG } from './config';
import * as SX from './sx';
import type { FilterExactMatchProps as Props } from './types';
import { useExactMatchSelected } from './use-exact-match-checked';
import { buildDraft } from './utils';

export const FilterExactMatch = memo(
  ({ className, label, field, default: defaultType, customOptions }: Props) => {
    const { params, setParam, removeParam } = useSearchQueryFilter({
      select: [field, 'exact_match'],
    });
    const selectedType = useExactMatchSelected(field, defaultType);

    const handleChange = (
      event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
      searchType: SearchMatchType
    ) => {
      const draft = buildDraft(field, params, searchType);
      if (draft.length) setParam('exact_match', draft);
      else removeParam('exact_match');
    };

    return (
      <Box
        className={classnames('FilterExactMatch', className)}
        sx={SX.root}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="body4" color="grey.500">
          {label ?? 'Search Match'}
        </Typography>
        <Box display="flex" gap={0.5}>
          {SEARCH_MATCH_BUTTONS_CONFIG.filter(
            (config) => !customOptions || customOptions.includes(config.type)
          ).map((config) => (
            <SearchMatchButton
              key={config.type}
              type={config.type}
              label={config.label}
              icon={config.icon}
              selected={selectedType === config.type}
              handleChange={handleChange}
            />
          ))}
        </Box>
      </Box>
    );
  }
);

FilterExactMatch.displayName = 'FilterExactMatch';
